<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <div class="l-top-navi__back-area">
          <a
            id="servicing-seatmap-sub-header-back"
            class="l-top-navi__back-link cursor-link"
            (click)="back()"
            tabindex="0"
            ><span class="u-visually-hidden" innerHTML="{{ 'reader.goBackToPreviousPage' | staticMsg }}"></span
          ></a>
        </div>
        <div class="l-top-navi__heading-area clear-left-margin top-navi-checkin-search">
          <h1
            class="l-top-navi__heading-text top-navi-checkin-search__heading"
            innerHTML="{{ 'label.seatMap' | staticMsg }}"
          ></h1>
          <!-- エコノミー(国内) -->
          <asw-tooltip
            iconImage="<img src=&quot;{{ appConstants.IMG.ICON_HELP }}&quot; alt=&quot;{{
              'alt.helpIcon2' | staticMsg
            }}&quot; width=&quot;20&quot; height=&quot;20&quot;>"
            tooltipContent="{{ 'tooltip.reservedSeatEconomy.dom' | staticMsg }}"
            [tooltipTop]="-85"
            *ngIf="isEconomy && isJapanDomesticFlight"
          >
          </asw-tooltip>
          <!-- エコノミー(国際) -->
          <asw-tooltip
            iconImage="<img src=&quot;assets/images/icon_help_primary_24.svg&quot; alt=&quot;{{
              'alt.helpIcon2' | staticMsg
            }}&quot; width=&quot;20&quot; height=&quot;20&quot;>"
            tooltipContent="{{ 'tooltip.reservedSeatEconomy.int' | staticMsg }}"
            [tooltipTop]="-85"
            *ngIf="isEconomy && !isJapanDomesticFlight"
          >
          </asw-tooltip>
          <!-- エコノミー以外(国内) -->
          <asw-tooltip
            iconImage="<img src=&quot;assets/images/icon_help_primary_24.svg&quot; alt=&quot;{{
              'alt.helpIcon2' | staticMsg
            }}&quot; width=&quot;20&quot; height=&quot;20&quot;>"
            tooltipContent="{{ 'tooltip.reservedSeatNotEconomy.dom' | staticMsg }}"
            [tooltipTop]="-85"
            *ngIf="!isEconomy && isJapanDomesticFlight"
          >
          </asw-tooltip>
          <!-- エコノミー以外(国際) -->
          <asw-tooltip
            iconImage="<img src=&quot;assets/images/icon_help_primary_24.svg&quot; alt=&quot;{{
              'alt.helpIcon2' | staticMsg
            }}&quot; width=&quot;20&quot; height=&quot;20&quot;>"
            tooltipContent="{{ 'tooltip.reservedSeatNotEconomy.int' | staticMsg }}"
            [tooltipTop]="-85"
            *ngIf="!isEconomy && !isJapanDomesticFlight"
          >
          </asw-tooltip>
        </div>
        <!-- [ヘッダー下メニュー ボタンエリア] -->
        <div class="l-top-navi__function-area">
          <div class="l-top-navi__function-item">
            <button
              id="servicing-seatmap-sub-header-4"
              class="l-top-navi__function-btn l-top-navi__function-btn--confirm"
              (click)="confirm()"
              [disabled]="isDisabledConfirm"
              [ngClass]="{ 'cursor-reset': isDisabledConfirm }"
            >
              <span class="l-top-navi__function-btn-text" innerHTML="{{ 'label.confirm1' | staticMsg }}"></span>
            </button>
          </div>
        </div>
        <!-- //[ヘッダー下メニュー ボタンエリア] -->

        <!--
        /=====================================================
        アクセシビリティ対応（読み上げ対策）のため、
        SP/TABの際は[ヘッダー下メニュー ボタンエリア] 、[ステップナビゲーション]の順でhtmlを出力してください
        PCの際は[ステップナビゲーション]、[ヘッダー下メニュー ボタンエリア]の順でhtmlを出力してください
        =====================================================/
        -->
      </div>
    </div>
  </div>
</div>
